// src/i18n/en/system.ts

const system = {
  title: 'System Information',
  description: 'Runtime status, storage and scheduled jobs, for support and diagnostics.',
  refresh: 'Refresh',
  lastUpdated: 'Last updated',

  cards: {
    overview: 'Overview',
    application: 'Application',
    database: 'Database',
    statistics: 'Statistics',
    secrets: 'Configuration & Secrets',
    logging: 'Logging',
    services: 'External Services & Health',
    jobs: 'Background Jobs',
  },

  // Generic categories for the database provider — the UI never names the
  // underlying engine, only its kind.
  database: {
    categoryRelational: 'Relational',
    categoryDocument: 'Document-oriented',
    categoryOther: 'Other',
  },

  fields: {
    version: 'Version',
    environment: 'Environment',
    uptime: 'Uptime',
    serverTime: 'Server Time',
    machineName: 'Machine',
    processorCount: 'Processors',
    osDescription: 'Operating System',
    dotnetVersion: 'Runtime version',
    hangfireServerName: 'Hangfire Server',
    isConnected: 'Connection',
    provider: 'Provider',
    pendingMigrations: 'Pending Migrations',
    appliedMigrations: 'Applied Migrations',
    databaseSize: 'Database Size',
    totalDevices: 'Total Devices',
    onlineDevices: 'Online Devices',
    totalHotels: 'Properties',
    totalGroups: 'Groups',
    totalEventsToday: 'Events Today',
    totalCheckInsToday: 'Check-ins Today',
    activeAlerts: 'Active Alerts',
  },

  secrets: {
    configured: 'Configured',
    notConfigured: 'Not configured',
    required: 'Required',
    optional: 'Optional',
    allConfigured: 'All required secrets are configured',
    missingRequired: '%{count} required secret(s) not configured',
    // Generic replacements for a technology name a secret's own display name
    // may carry verbatim from the API (never shown as-is).
    neutralTerms: {
      identityProvider: 'Identity provider',
      database: 'Database',
      logServer: 'Log server',
    },
  },

  logging: {
    sectionLabel: 'Log server',
    seqEnabled: 'Centralized logging enabled',
    seqUrl: 'Log server URL',
    seqApiKey: 'Log server API key',
    s3Enabled: 'S3 Storage Enabled',
    s3Url: 'S3 Service URL',
    s3Bucket: 'S3 Bucket',
    s3Credentials: 'S3 Credentials',
    installationId: 'Property ID',
    appName: 'Application Name',
    seqFilter: 'Log filter',
    copyFilter: 'Copy log filter',
    filterCopied: 'Log filter copied to clipboard',
    filterHelp: 'Use this filter in the log server to see logs from this application',
  },

  services: {
    name: 'Service',
    url: 'URL',
    status: 'Status',
    latency: 'Latency',
    reachable: 'Reachable',
    unreachable: 'Unreachable',
    recheck: 'Recheck',
  },

  health: {
    name: 'Check',
    status: 'Status',
    description: 'Description',
    duration: 'Duration',
    healthy: 'Healthy',
    degraded: 'Degraded',
    unhealthy: 'Unhealthy',
  },

  jobs: {
    name: 'Job Name',
    queue: 'Queue',
    schedule: 'Schedule',
    lastExecution: 'Last Execution',
    nextExecution: 'Next Execution',
    lastDuration: 'Duration',
    status: 'Status',
    actions: 'Actions',
    trigger: 'Run now',
    triggerSuccess: 'Job triggered successfully',
    triggerError: 'Failed to trigger job',
    neverExecuted: 'Never executed',
    description: 'Description',
  },

  status: {
    connected: 'Connected',
    disconnected: 'Disconnected',
    healthy: 'Healthy',
    degraded: 'Degraded',
    unhealthy: 'Unhealthy',
    succeeded: 'Succeeded',
    failed: 'Failed',
    processing: 'Processing',
    unknown: 'Unknown',
  },
};

export default system;
